// PermissionGuard.tsx
import React from "react";
import { Tooltip } from "@mui/material";
import { FaCrown } from "react-icons/fa";
import { useUserPermissions } from "../components/useUserPermissions.tsx";

interface PermissionGuardProps {
  requiredRank: string;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({ requiredRank }) => {
  const { hasPermission } = useUserPermissions();
  const permitted = hasPermission(requiredRank);
  const tooltipText = permitted
    ? "You have the required rank for this feature."
    : `Requires at least ${requiredRank} rank.`;
  return (
    <Tooltip title={tooltipText} arrow>
      <span>
        <FaCrown style={{ color: "blue", marginLeft: 4 }} />
      </span>
    </Tooltip>
  );
};

export default PermissionGuard;
